import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';
import { cn } from '~/utils/cn';
import { formatDateTime, formatRelative } from '~/utils/date';

/** "2 hours ago", with the absolute date-time on hover — the audit fields' time format. */
export function RelativeTime({
  iso,
  className,
  testId = 'relative-time',
}: {
  iso: string;
  className?: string;
  /** `data-testid` on the `<time>`; the hover tooltip gets `-tooltip`. */
  testId?: string;
}) {
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <time data-testid={testId} dateTime={iso} className={cn('cursor-default', className)}>
          {formatRelative(iso)}
        </time>
      </TooltipTrigger>
      <TooltipContent data-testid={`${testId}-tooltip`} className="text-xs">
        {formatDateTime(iso)}
      </TooltipContent>
    </Tooltip>
  );
}
